module.exports = __webpack_public_path__ + "img/icon05_highlight.60d4471.png";